// extracted by mini-css-extract-plugin
export var columnList = "_hj-0";